<template>
    <alert :title="__('orders.payment.pending')" type="light-danger">
        <template v-slot:icon>
            <i v-if="order.type === 'reservation'" class="fas fa-hand-holding-usd"/>
            <Spinner v-else
                     :size="30"
                     :line-size="6"
                     :speed="1.6"
                     line-fg-color="#ea4b4b"
                     line-bg-color="#ebc3c3"
            />
        </template>
        <template v-slot:default>
            <div v-if="order.type === 'reservation'">
                {{ __('orders.payment.paid_on_pickup') }}
                <div class="mt-1">
                    <button @click="markOrderAsPaid"
                            class="btn btn-xs btn-outline-danger"
                            :disabled="loading"
                    >
                        <i class="fas fa-check"/>
                        {{ __('actions.mark_as_paid') }}
                    </button>
                </div>
            </div>
            <div v-else>{{ __('orders.payment.not_yet_paid') }}</div>
        </template>
    </alert>
</template>

<script>
import Alert from '@components/Alert.vue';
import Spinner from 'vue-simple-spinner';
import { Link } from '@inertiajs/vue2';

export default {
    components: {
        Alert,
        Link,
        Spinner
    },

    props: {
        store: Object,
        order: Object,
    },

    data() {
        return {
            loading: false,
        };
    },

    methods: {
        markOrderAsPaid() {
            let vue = this;
            Swal.fire({
                text: __('orders.payment.received_question'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-success m-0',
                confirmButtonText: this.__('general.yes'),
                cancelButtonText: this.__('actions.abort'),
            }).then((result) => {
                if (result.value) {
                    vue.loading = true;
                    vue.$inertia.visit(this.$route('order.payment', [this.store.id, this.order.url_key]), {
                        data: {
                            state: 'paid',
                        },
                        method: 'PATCH',
                        only: ['order'],
                    });
                }
            });
        },
    },
};
</script>
